var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCalendarForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06033 2.85215C9.32599 2.59722 9.74801 2.60593 10.0029 2.87159L14.481 7.53826C14.7285 7.7962 14.7285 8.20347 14.481 8.46142L10.0029 13.1281C9.74801 13.3938 9.32599 13.4025 9.06033 13.1475C8.79467 12.8926 8.78596 12.4706 9.04089 12.2049L12.416 8.68766H2.66667C2.29848 8.68766 2 8.38919 2 8.021C2 7.65281 2.29848 7.35433 2.66667 7.35433H12.4566L9.04089 3.79475C8.78596 3.52909 8.79467 3.10707 9.06033 2.85215Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCalendarForwardArrow);
export default __webpack_public_path__ + "static/media/Custom-calendar-Forward-Arrow.776109d94e81cbffcc3dba33d69f6e15.svg";
export { ForwardRef as ReactComponent };